import React from 'react'

export type ShiftPageContextValues = {
  albertsons: boolean
}

export const ShiftPageContext = React.createContext<ShiftPageContextValues>({
  albertsons: false
})
